import { parsePhoneNumberWithError } from 'libphonenumber-js';

import { detectDeviceCountry } from '@/helpers/detect-default-country';



/*
  Decide which country the phone-number input's country selector should
  pre-select.

  Precedence:
    1. The user's already-saved phone number, if it parses to a known country.
       This is the closest proxy we have for "user's previously-chosen country"
       without adding a separate field to the user profile.
    2. The merchant's selected-location address country.
    3. The device's locale country (navigator.language region subtag).
    4. 'US' as a last-resort fallback.

  All sources are optional — callers pass what they have. The component
  always receives a usable ISO code in return.
*/

const FALLBACK_COUNTRY = 'US';



function countryFromSavedPhone(savedPhone) {
  if (!savedPhone) return null;

  try {
    const parsed = parsePhoneNumberWithError(String(savedPhone));

    if (parsed && parsed.country) return parsed.country;
  }
  catch (_error) { /* fall through */ }

  return null;
}



export default function detectDefaultPhoneCountry({ savedPhone, locationCountryCode } = {}) {
  const savedCountry = countryFromSavedPhone(savedPhone);
  if (savedCountry) return savedCountry;

  if (locationCountryCode) return String(locationCountryCode).toUpperCase();

  const deviceCountry = detectDeviceCountry();
  if (deviceCountry) return deviceCountry;

  return FALLBACK_COUNTRY;
}
